import pdpSharedMultiplePdpVisitsModalConfig from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';

export default [pdpSharedMultiplePdpVisitsModalConfig];
